import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { SideSliderValue, SideSliderVisibility, WidgetType } from '@mirage-projects/cw-commons';

/**
 * Service that manages the Side by Side slider bar component
 */
@Injectable({
    providedIn: 'root',
})
export class SideSliderService {
    private readonly valueChangeSubject$: Subject<SideSliderValue> = new Subject();
    readonly valueChange$ = this.valueChangeSubject$.asObservable();

    private readonly visibilityChangeSubject$: Subject<SideSliderVisibility> = new Subject();
    readonly visibilityChange$ = this.visibilityChangeSubject$.asObservable();

    private readonly invertColorsSubject$: Subject<boolean> = new Subject();
    readonly invertColors$ = this.invertColorsSubject$.asObservable();

    emitSideSliderValue(id: WidgetType, value: number): void {
        this.valueChangeSubject$.next({ id, value });
    }

    chageSideSliderVisibility(id: WidgetType, visible: boolean): void {
        this.visibilityChangeSubject$.next({ id, visible });
    }

    invertColors(invertColors = true): void {
        this.invertColorsSubject$.next(invertColors);
    }
}
